import { sendRequest } from "../libs/axiosConfig";
import { setToken } from "../utils/helperFunction";

export const loginApi = async (reqBody) => {
  const res = await sendRequest({
    method: 'POST',
    url: `/api/v1/users/login`,
    data: reqBody,
  });
  return res;
};

export const refreshUserApi = async () => {
  const res = await sendRequest({
    method: "get",
    url: `/api/v1/users/refresh-user-session`,
  });
  return res;
};

export const loginGoogleApi = async (reqBody) => {
  const { data } = await sendRequest({
    method: 'POST',
    url: `/api/v1/users/googlelogin`,
    data: reqBody,
  });
  return data;
};

export const getAdvisoryApi = async (reqBody) => {
  const { data } = await sendRequest({
    url: `/api/v1/industry/advisory`,
    method: "POST",
    body: reqBody,
  });
  return data;
};

export const addAdvisoryApi = async (reqBody) => {
  const { data } = await sendRequest({
    url: `/api/v1/industry/addadvisory`,
    method: "POST",
    body: { ...reqBody },
  });
  return data;
};

export const deleteAdvisoryApi = async (reqBody) => {
  const { data } = await sendRequest({
    url: `/api/v1/industry/deleteadvisory`,
    method: "POST",
    body: { ...reqBody },
  });
  return data;
};

export const editAdvisoryApi = async (reqBody) => {
  const { data } = await sendRequest({
    url: `/api/v1/industry/editadvisory`,
    method: "POST",
    body: { ...reqBody },
  });
  return data;
};

export const userTransactionHistoryApi = async () => {
  const { data } = await sendRequest({
    url: `/api/v1/users/transactionhistory`,
    method: "POST"
  });
  return data;
};

export const emailCheckApi = async (reqBody) => {
  const res = await sendRequest({
    method: "POST",
    url: `/api/v1/users/emailcheck`,
    data: reqBody,
  });
  return res;
};

export const logoutApi = async () => {
  const res = await sendRequest({ url: `/api/v1/users/logout` });
  setToken('');
  return res;
};


export const userRegisterApi = async (reqBody) => {
  const res = await sendRequest({
    url: "/api/v1/users/register",
    method: "POST",
    body: { ...reqBody },
  });
  return res;
};

export const peerRequestApi = async (reqBody) => {
  const res = await sendRequest({
    url: "/api/v1/users/peer-requests",
    method: "POST",
    body: { ...reqBody },
  });
  return res;
};

export const getPeerRequestApi = async () => {
  const res = await sendRequest({
    url: "/api/v1/users/peer-requests",
    method: "get"
  });
  return res;
};

export const updateUserProfileApi = async (formData) => {
  const res = await sendRequest({
    url: "/api/v1/users/updateprofile",
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data", // Ensure the content type is set to multipart
    },
  });
  return res;
};

export const getUserDetailApi = async (formData) => {
  const res = await sendRequest({
    url: "/api/v1/users/details",
    method: "get",
  });
  return res;
};

export const getExpertsApi = async (reqBody) => {
  const res = await sendRequest({
    url: "/api/v1/users/experts",
    method: "POST",
    body: { ...reqBody },
  });
  return res;
};

export const chatBotApi = async ({ message, userId }) => {
  const res = await sendRequest({
    url: `/api/v1/chats/${userId}`,
    method: 'POST',
    data: { message },
  });
  return res;
};


export const getEarlyBirdOfferApi = async () => {
  const res = await sendRequest({
    url: `/api/v1/users/earlybirdoffer`,
  });
  return res;
};

export const registerEarlyBirdOfferApi = async (reqBody) => {
  const { message, data } = await sendRequest({
    url: "/api/v1/users/earlybirdoffer",
    method: "POST",
    body: { ...reqBody },
  });
  return { message, data };
};

export const getexpertDetailProfileApi = async () => {
  const res = await sendRequest({
    url: "/api/v1/experts",
    method: "get"
  });
  return res;
};

export const chatBotsmeApi = async ({ message, userId, sectorName }) => {
  return await sendRequest({
    url: `/api/v1/smeChat/${userId}`,
    method: "POST",
    data: {
      message,
      sme_activity_sector: sectorName,  
    },
  });
};
// sectorSummaryApi.js

export const sectorSummaryApi = async ({ sectorName }) => {
  return await sendRequest({
    url: `/api/v1/sectorSummary/${encodeURIComponent(sectorName)}`,
    method: "GET"
  });
};


export const userModuleApi = async () => {
  return await sendRequest({
    url: `/api/v1/plan-module`,
    method: "GET"
  });
};



export const startSessionApi = async (reqBody) => {
  const res = await sendRequest({
    method: "POST",
    url: `/api/v1/sessions/start`,
    data: reqBody,
  });
  return res;
};

export const endSessionApi = async (reqBody) => {
  const res = await sendRequest({
    method: "POST",
    url: `/api/v1/sessions/end`,
    data: reqBody,
  });
  return res;
};

export const npsApi = async (reqBody) => {
  const res = await sendRequest({
    method: "POST",
    url: `/api/v1/nps/answer-score`,
    data: reqBody,
    withCredentials: true 
  });
  return res;
};

export const adminNpsApi = async () => {
  return await sendRequest({
    url: "/api/v1/admin/nps",
    method: "GET",
  });
};